import localization from "../../../../config/localization";
import common from "../../../../utils/common";
import { formatTimestampToLocalDateTime } from "../../../../utils/dateTimeHelper";
import {
  BetHistory,
  SportsHistorySummaryResponse,
} from "../../models/response/sportsHistorySummaryResponse";
import { SPORTS_STATUS_STYLE } from "../../models/constants/statusStyles";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { TransactionStatusTypes } from "../../../../models/constants/transactionStatusTypes";

export default function SystemBet({
  betDetails,
  sysBetsArray,
  betStrings,
}: {
  betDetails: BetHistory;
  sysBetsArray: SportsHistorySummaryResponse[][];
  betStrings: string[];
}) {
  const firstItem = betDetails.betHistorydetails?.[0];
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    setOpenIndex(null);
  }, []);

  return (
    <div className="pb-2">
      <div className="grid gap-y-2 pb-2 border-b border-[#353535]">
        <div>
          <span>{localization.betid}</span>
          <span className="float-right text-white">
            {betDetails.betslipId}
            <img
              src={"/icons/ic-copy.svg"}
              alt="Copy"
              className="size-4 inline ml-2 cursor-pointer"
              onClick={() =>
                common.copyIdToClipboard(
                  betDetails.betslipId!,
                  localization.betslipid_success_copied,
                )
              }
            />
          </span>
        </div>

        <div>
          <span>{localization.potentialwin}</span>
          <span className="float-right text-white">{`${firstItem?.potentialWin}\u20B9`}</span>
        </div>

        <div>
          <span>{localization.bet}</span>
          <span className="float-right text-white">
            {betStrings &&
              betStrings.map((bet, index) => {
                const betData = bet.split("x");

                return (
                  <p key={index} className="flex justify-end my-1">
                    <span>{`${betData[0]} x ${betData[1]}\u20B9`}</span>
                  </p>
                );
              })}
          </span>
        </div>
      </div>

      {betDetails.betHistorydetails &&
        betDetails.betHistorydetails.length > 0 &&
        sysBetsArray?.map((comboBets, index) => {
          const isOpen = openIndex === index;

          let combinationOdd = 1;
          comboBets.forEach((item) => {
            const status = item.status?.toLowerCase();

            const takenOdds =
              item.matchOdds != null &&
              item.matchOdds !== 0 &&
              status !== TransactionStatusTypes.HALF_WIN.toLocaleLowerCase() &&
              status !== TransactionStatusTypes.HALF_LOST.toLocaleLowerCase()
                ? Number(item.matchOdds)
                : Number(item.odds);

            combinationOdd *= takenOdds;
          });

          return (
            <div key={index}>
              <div
                className="border-b border-[#353535] my-2 py-2 flex items-center justify-between cursor-pointer"
                onClick={() => setOpenIndex(isOpen ? null : index)}
              >
                <span className="font-medium text-sm text-[#A9A9A9]">
                  Combination {String(index + 1).padStart(2, "0")}
                </span>
                <div>
                  <span className="font-medium text-sm text-white mr-2">
                    {combinationOdd.toFixed(2)}
                  </span>
                  <span>
                    <FontAwesomeIcon icon={isOpen ? faMinus : faPlus} />
                  </span>
                </div>
              </div>

              {isOpen &&
                comboBets.map((summaryItem, innerIndex) => {
                  return (
                    <div
                      key={innerIndex}
                      className="grid gap-y-2 mt-2 py-2 border-b-[3px] border-dashed border-[#3C3C3C]"
                    >
                      <div className="grid grid-cols-6">
                        <div className="col-span-4 flex items-center">
                          <span className="font-medium text-sm text-white truncate">
                            <img
                              src={
                                summaryItem.sportName
                                  ? `/icons/sports/sport-name/sport-${summaryItem.sportName.toLowerCase().replace(" ", "").replace(":", "-")}.svg`
                                  : "/icons/ic-tanis.svg"
                              }
                              alt="Sports Name"
                              className="size-4 invert inline mr-1 relative -top-[2px]"
                              onError={(e) => {
                                const target = e.currentTarget;
                                target.onerror = null;
                                target.src = "/icons/sports-icon-active.svg";
                              }}
                            />
                            {summaryItem.competitorName}
                          </span>
                          {summaryItem.isLive && (
                            <span>
                              <img
                                src="/icons/ic-live.svg"
                                alt="Live"
                                className="size-7 inline ml-1"
                              />
                            </span>
                          )}
                        </div>

                        {summaryItem.status && (
                          <div className="col-span-2">
                            <span
                              className={`float-right font-medium p-1 text-xs md:text-sm rounded-sm ${
                                SPORTS_STATUS_STYLE[
                                  summaryItem.status
                                    .trim()
                                    .toLowerCase()
                                    .replace(" ", "_")
                                ]
                              }`}
                            >
                              {localization.getString(
                                summaryItem.status
                                  .trim()
                                  .toLowerCase()
                                  .replace(" ", "_"),
                              )}
                            </span>
                          </div>
                        )}
                      </div>

                      <div>
                        <span className="font-medium text-sm text-white">
                          {summaryItem.outComeName}
                        </span>
                      </div>

                      <div>
                        <span>{localization.league_name}</span>
                        <span className="float-right font-medium text-sm text-white">
                          {summaryItem.tournamentName}
                        </span>
                      </div>

                      <div>
                        <span>{localization.event_date}</span>
                        <span className="float-right font-medium text-sm text-white">
                          {formatTimestampToLocalDateTime(
                            summaryItem.scheduled,
                          )}
                        </span>
                      </div>

                      <div>
                        <span>{localization.odds}</span>
                        <span className="float-right font-medium text-sm text-white">
                          {summaryItem.odds.toFixed(2)}
                        </span>
                      </div>
                    </div>
                  );
                })}
            </div>
          );
        })}
    </div>
  );
}
